import React from "react";
import Header from "../../../commons/Header/Header";
import Footer from "../../../commons/Footer/Footer";
import "./TermsConditions.css";
// Removed GLobalLinks
const TermsConditions = (props) => {
  return (
    <>
    <Header en="/terms-conditions" fr="/modalites-et-conditions" lang="en" />
    <div className="container mainDiv ab">
      <div className="row">
        <div className="col-xs-12 content">
          <h1 className="terms-conditions">Terms and Conditions</h1>
          <div>
            <p>Welcome! These Terms and Conditions ("Terms") constitute a legally binding agreement between you ("you", "your", "User") and Travelance Inc., including its Travelance.ca® website and MyTL® software platform (collectively, "Travelance"). Travelance Inc. is an intellectual web property and lead-generation insurance technology company ("us", "we"). By viewing, accessing, using or browsing the Travelance platforms such as Travelance.ca (<a href="https://www.travelance.ca">https://www.travelance.ca</a>) or MyTL software or by registering as a consumer of any Services (defined below), you agree to these Terms in full. If you do not agree, you must immediately cease all use of Travelance platforms and Services.</p>
            <hr />
            <ol className="tltermscondition">
              <li>
                <h2>Implied Covenant</h2>
                <p>We offer the opportunity to obtain insurance quotes and, where available, purchase insurance products through third-party carriers. All quotes depend on factors beyond our control (e.g., location, driving record, insurer criteria). We do not guarantee availability, accuracy, or pricing of any quote or product. You agree to indemnify and hold harmless Travelance Inc., its owners, affiliates, officers, employees, agents and representatives from any claim, loss, or liability arising from any quote or purchase obtained via the Site.</p>
              </li>
              <li>
                <h2>Application of These Terms</h2>
                <p>This Site is operated by Travelance Inc. to deliver a Service (&quot;Services&quot;) enabling adults to obtain quotes and purchase insurance products. Quotes vary by insurer; Travelance Inc. is not responsible for mis-quotes or policy changes by insurers. Consumers should verify quotes directly with the issuing agency. We hold no authority to bind or modify any policy.</p>
              </li>
              <li>
                <h2>Definitions</h2>
                <ul>
                  <li><b>Consumer</b>: A person using the Site or Services for personal, non-commercial purposes.</li>
                  <li><b>Account</b>: Your user profile, including username, password, and registered information.</li>
                  <li><b>Content</b>: Material on the Site, including text, graphics, images, videos, software, and data.</li>
                  <li><b>Materials</b>: Content plus User-Generated Content displayed or submitted on the Site.</li>
                  <li><b>Services</b>: Insurance quote lead-generation, comparison tools, and related support services.</li>
                </ul>
              </li>
              <li>
                <h2>Access and License</h2>
                <p>Travelance Inc. grants you a limited, non-exclusive, non-transferable license to access and use the Site per these Terms. We may withdraw or amend the Site or Services at any time, with or without notice. You are
                responsible for all equipment and Internet access required to use the Site.</p>
              </li>
              <li>
                <h2>Registration, Account Security, and Age of Majority</h2>
                <ol type="1">
                  <li><b>Registration</b>: To access certain features, you must register with accurate, current and complete information and update it as necessary.</li>
                  <li><b>Account Security</b>: Keep your credentials confidential. Notify us immediately of any unauthorized use or security breach.</li>
                  <li><b>Age</b>: You represent that you are at least the legal age of majority in your jurisdiction. If underage, exit the Site immediately.</li>
                </ol>
              </li>
              <li>
                <h2>Purchases, Fees, and Payment</h2>
                <ol>
                  <li><b>Fees</b>: All fees are displayed at purchase and may change for future orders, not existing ones.</li>
                  <li><b>Payment</b>: Processed via third-party gateways; you authorize charges for all fees incurred.</li>
                  <li><b>Refunds</b>: Services are non-refundable unless otherwise specified; unused portions may be refunded after sufficient proof is provided, and as per the policy contract.</li>
                </ol>
              </li>
              <li>
                <h2>Content Ownership and Intellectual Property</h2>
                <p>All Materials on the Site including text, graphics, photographs, video and audio clips, music, soundtracks, button icons, streaming data, animations, and downloadable software are the property of Travelance Inc. or its licensors and are protected by Canadian and international copyright, trademark, patent, trade secret, and other intellectual property laws.</p>
                <ol className="custom-ol seven">
                  <li>
                    <b>Copyright</b>
                    <ul>
                      <li>All original Content, including website design, logos, and proprietary software, &copy; Travelance Inc. 2013-2025.</li>
                      <li>Unauthorized copying, reproduction, distribution, public display, or creation of derivative works is strictly prohibited.</li>
                      <li>You may download or print one copy of the Materials solely for your personal, non-commercial use, provided all copyright and proprietary notices remain intact.</li>
                    </ul>
                  </li>
                  <li>
                    <b>Trademarks and Service Marks</b>
                    <ul>
                      <li>"Travelance", the Travelance Inc. logo (THE GUARDIAN), domain names, product names, and slogans are registered and common-law trademarks of Travelance Inc.</li>
                      <li>All other trademarks and service marks on the Site are the property of their respective owners.</li>
                      <li>No license or right to use any trademark is granted without the owner&rsquo;s prior written permission.</li>
                    </ul>
                  </li>
                  <li>
                    <b>Patents and Trade Secrets</b>
                    <ul>
                      <li>Certain technologies, processes, and software components of the Site may be protected by patents or maintained as trade secrets.</li>
                      <li>You agree not to reverse engineer, decompile, or disassemble any part of the Site to uncover underlying technology or trade secrets.</li>
                    </ul>
                  </li>
                  <li>
                    <b>License to Use Site Content</b>
                    <p>Subject to your compliance with these Terms, Travelance Inc. grants you a limited, revocable, non-exclusive, non-transferable license to access, view, and use the Site Content solely for personal, non-commercial purposes.</p>
                  </li>
                  <li>
                    <b>Marking and Notice</b>
                    <ul>
                      <li>All copyright, trademark, and patent notices on Materials must remain unaltered.</li>
                      <li>Any removal or alteration of such notices constitutes a material breach of these Terms.</li>
                    </ul>
                  </li>
                </ol>
              </li>
              <li>
                <h2>User-Generated Content</h2>
                <p>By submitting reviews, feedback or media, you grant Travelance Inc. a worldwide, royalty-free, irrevocable license to use, reproduce, modify, publish, and distribute such content. You represent that you have rights to submit this content.</p>
              </li>
              <li>
                <h2>Cookies and Tracking Technologies</h2>
                <p>We use cookies and similar tracking technologies to enhance your experience on the Site. Cookies are small text files placed on your device when you visit a website. They help us recognize your browser, remember your preferences, and track usage patterns.</p>
                <ol className="custom-ol nine">
                  <li>
                    <b>Types of Cookies</b>
                    <ul>
                      <li>Essential Cookies: Necessary for core functionality (e.g., login sessions, security).</li>
                      <li>Performance Cookies: Collect anonymous data on Site usage (e.g., pages visited, time spent) to help us improve performance and user experience.</li>
                      <li>Functional Cookies: Remember choices you make (e.g., language, currency) to provide personalized features.</li>
                      <li>Advertising/Targeting Cookies: Track browsing habits to deliver relevant ads on our Site and across third-party platforms.</li>
                    </ul>
                  </li>
                  <li>
                    <b>Third-Party Cookies</b>
                    <p>We allow third-party service providers (e.g., analytics, advertising networks) to place cookies on your device. These providers use cookies to collect information about your online activities over time and across different websites.</p>
                  </li>
                  <li>
                    <b>Cookie Duration</b>
                    <ul>
                      <li><b>Session Cookies</b>: Deleted when you close your browser.</li>
                      <li><b>Persistent Cookies</b>: Remain on your device until they expire or you delete them (duration varies by cookie).</li>
                    </ul>
                  </li>
                  <li>
                    <b>Purpose of Cookies</b>
                    <ul>
                      <li>Enable core Site functions and security.</li>
                      <li>Understand and analyze Site usage to enhance performance.</li>
                      <li>Remember your preferences and settings.</li>
                      <li>Provide tailored advertisements.</li>
                    </ul>
                  </li>
                  <li>
                    <b>Managing Cookies</b>
                    <p>You can manage or delete cookies through your browser settings. Most browsers allow you to:</p>
                    <ul>
                      <li>View the cookies stored on your device.</li>
                      <li>Block or delete cookies.</li>
                      <li>Block cookies from specific sites or all sites.</li>
                      <li>Receive a warning before a cookie is stored.</li>
                    </ul>
                  </li>
                </ol>
                <p>For detailed instructions, visit your browser&rsquo;s help section (e.g., Chrome, Firefox, Safari, Edge). Please note that disabling cookies may affect Site functionality and your user experience.</p>
              </li>
              <li>
                <h2>Privacy Policy</h2>
                <p>Our <a href="https://www.travelance.ca/privacy-policy" >Privacy Policy</a> explains how we collect and use personal information. By using the Site, you consent to these practices.</p>
              </li>
              <li>
                <h2>Prohibited Conduct</h2>
                <p>You agree not to:</p>
                <ul>
                  <li>Use the Site unlawfully or unauthorized.</li>
                  <li>Post defamatory, obscene, or abusive content.</li>
                  <li>Upload malicious code or viruses.</li>
                  <li>Attempt unauthorized access or data scraping.</li>
                  <li>Circumvent security or interfere with Site operations.</li>
                </ul>
              </li>
              <li>
                <h2>Third-Party Links and Services</h2>
                <p>The Site may link to external websites. Travelance Inc. does not endorse and is not responsible for their content or practices. Your use of third-party resources is at your risk.</p>
              </li>
              <li>
                <h2>Disclaimer of Warranties</h2>
                <p>The site and services are provided &quot;as-is&quot; and &quot;as available,&quot; without warranties of any kind. Travelance Inc. disclaims all express and implied warranties.</p>
              </li>
              <li>
                <h2>Limitation of Liability</h2>
                <p>To the maximum extent permitted by law, Travelance Inc.&rsquo;s total liability shall not exceed the fees paid by you in the six (6) months prior to the claim. We are not liable for any indirect, incidental, special, or consequential damages.</p>
              </li>
              <li>
                <h2>Indemnification</h2>
                <p>You agree to defend, indemnify, and hold harmless Travelance Inc. and its affiliates from any claims arising from your breach of these Terms or your use of the Site.</p>
              </li>
              <li>
                <h2>Notice and Takedown (DMCA-Style)</h2>
                <p>Travelance Inc. respects the intellectual property rights of others and follows the procedures set forth in the Digital Millennium Copyright Act (DMCA).</p>
                <ol className="custom-ol sixteen">
                  <li>
                    <b>Notification of Claimed Infringement</b>
                    <p>To file a notice of copyright infringement, submit a written notification containing all of the following to our Designated Agent (<a href="mailto:admin@travelance.ca">admin@travelance.ca</a>):</p>
                    <ol>
                      <li>A physical or electronic signature of the copyright owner or a person authorized to act on their behalf.</li>
                      <li>Identification of the copyrighted work(s) claimed to have been infringed.</li>
                      <li>Identification (including URL) of the material that is claimed to be infringing and where it is located on the Site.</li>
                      <li>Your name, address, telephone number, and email address.</li>
                      <li>A statement by you, under penalty of perjury, that you have a good-faith belief the use is unauthorized.</li>
                      <li>A statement by you, under penalty of perjury, that the information in your notice is accurate and you are the copyright owner or authorized to act on their behalf.</li>
                    </ol>
                  </li>
                  <li>
                    <b>Review and Removal</b>
                    <p>Upon receipt of a valid notice, Travelance Inc. will:</p>
                    <ul>
                      <li>Expeditiously remove or disable access to the allegedly infringing material.</li>
                      <li>Notify the user who posted the material of its removal.</li>
                    </ul>
                  </li>
                  <li>
                    <b>Counter-Notification by User</b>
                    <p>If you believe your content was removed in error, you may submit a counter-notification to <a href="mailto:admin@travelance.ca">admin@travelance.ca</a> containing:</p>
                    <ol>
                      <li>Your physical or electronic signature.</li>
                      <li>Identification of the removed material and its location before removal.</li>
                      <li>A statement, under penalty of perjury, that you have a good-faith belief the removal was due to misidentification.</li>
                      <li>Your name, address, telephone number, and email address.</li>
                      <li>A statement consenting to jurisdiction in the federal district court for your address or, if outside the U.S., any judicial district where Travelance Inc. may be found.</li>
                    </ol>
                    <p>Upon receipt of a valid counter-notification, Travelance Inc. will restore the content within 10-14 business days unless the original complainant files a court action seeking to restrain the user from engaging in infringing activity.</p>
                  </li>
                  <li>
                    <b>Repeat Infringers</b>
                    <p>Travelance Inc. reserves the right to terminate accounts of users who are found to be repeat infringers in appropriate circumstances.</p>
                  </li>
                </ol>
              </li>
              <li>
                <h2>Export Control Export Control</h2>
                <p>You may not export any part of the Site or Services in violation of Canadian or international export laws. You warrant you are not in an embargoed country.</p>
              </li>
              <li>
                <h2>No Agency Relationship</h2>
                <p>Nothing in these Terms creates an agency, partnership, joint venture, or employment relationship between you and Travelance Inc.</p>
              </li>
              <li>
                <h2>Notices</h2>
                <ol className="custom-ol ninteen">
                  <li>
                    <b>Method of Notice</b>
                    <p>We may send notices by email, general Site posting, or commercial carrier.</p>
                  </li>
                  <li>
                    <b>Change of Address</b>
                    <p>Update your contact details via your Account settings; we&rsquo;ll use the latest information on file.</p>
                  </li>
                  <li>
                    <b>When Notice is Effective</b>
                    <p>Email or fax notices are effective one hour after sending during business hours, or next business day if sent after hours.</p>
                  </li>
                  <li>
                    <b>Refused, Unclaimed or Undeliverable Notice</b>
                    <p>If a correctly addressed notice is refused or undeliverable due to your act or omission, it is deemed effective as of the first refusal or attempted delivery date.</p>
                  </li>
                </ol>
              </li>
              <li>
                <h2>Force Majeure</h2>
                <p>We are not liable for delays or failures due to causes beyond reasonable control (e.g., natural disasters, war, strikes, Internet failures).</p>
              </li>
              <li>
                <h2>Applicable Law</h2>
                <p>These Terms shall be governed by and construed in accordance with the laws of the Province of Ontario, Canada, without regard to its conflict-of-law principles. The application of the United Nations Convention on Contracts for the International Sale of Goods is expressly excluded.</p>
              </li>
              <li>
                <h2>Dispute Resolution</h2>
                <ol>
                  <li><b>Negotiation.</b>
                   Parties agree to first attempt to resolve any dispute arising under these Terms through good-faith negotiations within 30 days of written notice of the dispute.</li>
                  <li><b>Arbitration.</b> If unresolved, either party may submit the dispute to binding arbitration under the Canadian Arbitration Association&rsquo;s Commercial Arbitration Rules, to be conducted in Toronto, Ontario by a single arbitrator.
                  The arbitration award is final and binding, and judgment may be entered in any court of competent jurisdiction.</li>
                  <li><b>Venue and Jurisdiction.</b> The parties submit to the exclusive jurisdiction of the courts of Ontario for any enforcement of an arbitration award or other judicial proceedings not subject to arbitration. </li>
                </ol>
              </li>
              <li>
                <h2>General Provisions</h2>
                <ul>
                  <li><b>Assignment</b>: You may not assign these Terms; we may assign freely.</li>
                  <li><b>Severability</b>: Invalid provisions do not affect the remainder.</li>
                  <li><b>No Waiver</b>: Failure to enforce any right is not a waiver.</li>
                  <li><b>Entire Agreement</b>: These Terms, Privacy Policy, and Terms of Use constitute the full agreement.</li>
                </ul>
              </li>
              <li>
                <h2>Confidential Information</h2>
                <p>You agree to keep any confidential information obtained through the Site secure and not disclose it to third parties. Confidential Information includes business plans, pricing, user data, and proprietary processes.</p>
              </li>
              <li>
                <h2>Contact Information</h2>
                <p>If you have any questions regarding these Terms and Conditions, please contact us using this form: <a href="https://www.travelance.ca/contact-us/">www.travelance.ca/contact/</a> or by email to <a href="mailto:admin@travelance.ca">admin@travelance.ca</a>.</p>
              </li>
            </ol>
            <p><b>Effective Date</b>: July 02, 2013</p>
            <p><b>Last Updated</b>: June 04, 2025</p>
          </div>
        </div>
      </div>
    </div>
    <Footer lang="en" />
    </>
  );
}

export default TermsConditions;
